import type {Config} from './types/config.ts';
import {RequestContext} from './lib/ssrHelper.ts';

export const config: Config =
    typeof window !== 'undefined'
        ? (window.config as unknown as Config) || ({} as Config)
        : ((global.requestContext as RequestContext).config as Config);
